import http from "./httpService";
const apiEndpoint = "/messenger";

export function manageMessenger(projectId, req) {
  return http.post(apiEndpoint + "/manage/whitelabelRegister/" + projectId, req);
}

function getMessengerConfig(projectId) {
  return http.get(`/messenger/manage/whitelabelConfig/${projectId}`);
}

function deleteMessengerConfig(projectId) {
  return http.delete(`${apiEndpoint}/manage/whitelabelConfig/${projectId}`);
}

export { getMessengerConfig, deleteMessengerConfig };
